import type { Step } from 'react-joyride';

export const DASHBOARD_TOUR_STEPS: Step[] = [
  {
    target: 'body',
    content: "This is your dashboard. From here you can create projects, use templates, and manage your AR storytelling experiences. Let's take a quick look around.",
    title: 'Welcome to Lureo',
    placement: 'center',
    disableBeacon: true,
    disableScrolling: true
  },
  {
    target: '[data-tour="hero-ctas"]',
    content: 'Download the app, book a call, join Discord, or watch tutorials.',
    title: 'Quick Actions',
    disableBeacon: true,
    disableScrolling: true
  },
  {
    target: '[data-tour="my-account"]',
    content: 'Access your profile, settings, and subscription here.',
    title: 'My Account',
    disableBeacon: true
  },
  {
    target: '[data-tour="template-stories"]',
    content: 'Check out these templates from the Lureo Team & Creator Community. Use them to get started quickly or as inspiration for your own projects.',
    title: 'Template Stories',
    disableBeacon: true
  },
  {
    target: '[data-tour="projects-section"]',
    content: 'Projects are where your AR experiences live. Each project can have one or more stories.',
    title: 'Your Projects',
    disableBeacon: true
  },
  {
    target: '[data-tour="new-project"]',
    content: 'Create a new project to start building your AR experience.',
    title: 'Create a Project',
    disableBeacon: true
  }
];
